import TruckThinIcon from '../../public/static/icons/truck-thin.svg';
import FormattedText from '../../components/01_atoms/FormattedText';

import s from './index.module.scss';

export type Props = {
  title?: string;
  description?: string;
};

const ShippingInfoMessage = ({ title, description }: Props) => {
  return (
    <div className={s['shipping-info-message']}>
      <TruckThinIcon className={s['shipping-info-message__icon']} />
      <div className={s['shipping-info-message__message']}>
        {title && <div className={s['shipping-info-message__title']}>{title}</div>}
        {description && (
          <div className={s['shipping-info-message__description']}>
            <FormattedText text={description} />
          </div>
        )}
      </div>
    </div>
  );
};

export default ShippingInfoMessage;
